import { useState, useRef, useEffect } from 'react';
import { X } from 'lucide-react';

const COLUMN_TYPES = [
  { type: 'text', label: 'Texto', icon: 'Aa' },
  { type: 'status', label: 'Status', icon: '●' },
  { type: 'person', label: 'Pessoa', icon: '👤' },
  { type: 'date', label: 'Data', icon: '📅' },
  // Mesmo tipo 'date'; o que muda é o config (um calendário só, ver DateCell). Sem tipo novo.
  { type: 'date', label: 'Data de vencimento', icon: '⏰', config: { mode: 'single' } },
  { type: 'number', label: 'Número', icon: '#' },
  { type: 'currency', label: 'Moeda (R$)', icon: 'R$' },
  { type: 'select', label: 'Select', icon: '▾' },
  { type: 'checkbox', label: 'Checkbox', icon: '☑' },
  { type: 'link', label: 'Link', icon: '🔗' },
  { type: 'created', label: 'Log de Criação', icon: '🕐' },
  { type: 'updated', label: 'Última atualização', icon: '🔄' },
];

export default function AddColumnModal({ onClose, onCreate }) {
  const [step, setStep] = useState('type');
  const [selected, setSelected] = useState(null); // entrada de COLUMN_TYPES (type + config)
  const [name, setName] = useState('');
  const nameRef = useRef(null);

  useEffect(() => {
    if (step === 'name' && nameRef.current) nameRef.current.focus();
  }, [step]);

  const handleSelectType = (entry) => {
    setSelected(entry);
    setName(entry.label);
    setStep('name');
  };

  const handleCreate = () => {
    const trimmed = name.trim();
    if (!trimmed) return;
    onCreate(trimmed, selected.type, { ...selected.config });
    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50" onClick={onClose}>
      <div
        className="bg-card rounded-xl border border-border shadow-2xl w-[360px]"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between px-5 py-4 border-b border-border/50">
          <h3 className="text-sm font-semibold text-text-primary">
            {step === 'type' ? 'Escolha o tipo da coluna' : 'Nome da coluna'}
          </h3>
          <button onClick={onClose} className="text-text-secondary hover:text-text-primary transition-colors">
            <X className="w-4 h-4" />
          </button>
        </div>

        <div className="p-4">
          {step === 'type' ? (
            <div className="grid grid-cols-2 gap-2">
              {COLUMN_TYPES.map((ct) => (
                <button
                  key={ct.label}
                  onClick={() => handleSelectType(ct)}
                  className="flex items-center gap-3 px-4 py-3 rounded-lg border border-border/50 hover:border-accent/50 hover:bg-accent/5 transition-all text-left"
                >
                  <span className="text-lg w-6 text-center">{ct.icon}</span>
                  <span className="text-sm text-text-primary">{ct.label}</span>
                </button>
              ))}
            </div>
          ) : (
            <div className="space-y-4">
              <input
                ref={nameRef}
                value={name}
                onChange={(e) => setName(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') handleCreate();
                  if (e.key === 'Escape') onClose();
                }}
                placeholder="Nome da coluna..."
                className="w-full bg-main border border-border rounded-lg px-4 py-2.5 text-sm text-text-primary placeholder-text-secondary/50 outline-none focus:border-accent/50"
              />
              <div className="flex justify-end gap-2">
                <button
                  onClick={() => setStep('type')}
                  className="px-4 py-2 text-sm text-text-secondary hover:text-text-primary transition-colors"
                >
                  Voltar
                </button>
                <button
                  onClick={handleCreate}
                  disabled={!name.trim()}
                  className="px-4 py-2 text-sm font-medium bg-accent text-white rounded-lg hover:bg-accent/80 transition-colors disabled:opacity-40"
                >
                  Criar
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
